import { Radio as NextRadio } from "@heroui/react";
import { withFormComponent } from "./hoc";

export const Radio = withFormComponent(NextRadio); 